<template>
  <j-modal
    :title="'库存调拨 - ' + title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    :forceRender="true"
    switchFullscreen
    :fullscreen="true"
    @cancel="handleCancel">

    <template slot="footer">
      <a-button v-if="action!=='detail'" key="cancel" @click="handleCancel">取消</a-button>
      <a-button v-if="!readOnly" key="save" @click="handleSave" type="primary" :loading="confirmLoading">保存</a-button>
      <a-button v-if="!readOnly" key="submit" @click="handleSubmit" type="primary" :loading="confirmLoading">提交
      </a-button>
      <a-button v-if="action==='detail'" key="close" @click="handleCancel" type="primary">关闭</a-button>
      <a-button v-if="action==='approve'" key="approved" @click="handleApproved" type="primary">审核通过</a-button>
    </template>

    <a-spin :spinning="confirmLoading">
      <!-- 主表单区域 -->
      <a-form :form="form">

        <a-row>
          <a-col :span="8">
            <a-form-item label="单据编号" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <a-input :readOnly="true" v-decorator="[ 'billNo', validatorRules.billNo]"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="单据日期" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-date :readOnly="readOnly" placeholder="请选择单据日期" v-decorator="[ 'billDate', validatorRules.billDate]"
                      :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="处理状态" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-dict-select-tag disabled type="list" v-decorator="['billProcStatus', validatorRules.billProcStatus]"
                                 :trigger-change="true" dictCode="x_bill_proc_status"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!--sourceType、sourceId、sourceNo应一起考虑-->
            <a-form-item label="源单号" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <a-input-search :readOnly="readOnly" v-decorator="[ 'sourceNo', validatorRules.sourceNo]"
                              placeholder="请输入源单号" enter-button="引入要货申请"
                              @search="handleSourceOrderSelect($event)"></a-input-search>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="调出仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="readOnly" type="list" v-decorator="['pullWarehouse', validatorRules.pullWarehouse]" :trigger-change="true"
                                 dictCode="bas_warehouse,name,id" placeholder="请选择调出仓库" @change="handlePullWarehouseChange($event)"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="调入仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag :disabled="readOnly" type="list" v-decorator="['pushWarehouse', validatorRules.pushWarehouse]" :trigger-change="true"
                                 dictCode="bas_warehouse,name,id" placeholder="请选择调入仓库" @change="handlePushWarehouseChange($event)"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-show="moreStatus">
          <a-col :span="4">
            <a-form-item label="是否通过" :labelCol="spans.labelCol6" :wrapperCol="spans.wrapperCol6">
              <j-dict-select-tag disabled type="list" v-decorator="['isApproved', validatorRules.isApproved]"
                                 :trigger-change="true" dictCode="yn"/>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="是否关闭" :labelCol="spans.labelCol6" :wrapperCol="spans.wrapperCol6">
              <j-dict-select-tag disabled type="list" v-decorator="['isClosed', validatorRules.isClosed]"
                                 :trigger-change="true" dictCode="yn"/>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="是否作废" :labelCol="spans.labelCol6" :wrapperCol="spans.wrapperCol6">
              <j-dict-select-tag disabled type="list" v-decorator="['isVoided', validatorRules.isVoided]"
                                 :trigger-change="true" dictCode="yn"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="创建时间" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-date :readOnly="true" v-decorator="[ 'createTime', validatorRules.createTime]" :trigger-change="true"
                      style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="创建人" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-dict-select-tag disabled type="list" v-decorator="['createBy', validatorRules.createBy]"
                                 :trigger-change="true" dictCode="sys_user,realname,username"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="创建部门" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-dict-select-tag disabled type="list" v-decorator="['sysOrgCode', validatorRules.sysOrgCode]"
                                 :trigger-change="true" dictCode="sys_depart,depart_name,org_code"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="生效时间" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-date :readOnly="true" v-decorator="[ 'effectiveTime', validatorRules.effectiveTime]" :showTime="true"
                      :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="审核人" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-dict-select-tag disabled type="list" v-decorator="['approverId', validatorRules.approverId]"
                                 :trigger-change="true" dictCode="sys_user,realname,username"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="流程" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <a-input :readOnly="true" v-decorator="[ 'flowId', validatorRules.flowId]"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="修改时间" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-date :readOnly="true" v-decorator="[ 'updateTime', validatorRules.updateTime]" :trigger-change="true"
                      style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="修改人" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-dict-select-tag disabled type="list" v-decorator="['updateBy', validatorRules.updateBy]"
                                 :trigger-change="true" dictCode="sys_user,realname,username"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="是否红字" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">
              <j-dict-select-tag type="list" v-decorator="['isRubric', validatorRules.isRubric]" :trigger-change="true"
                                 dictCode="yn"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="附件" :labelCol="spans.labelCol1" :wrapperCol="spans.wrapperCol1">
              <j-upload :disabled="readOnly" v-decorator="['attachment', validatorRules.attachment]"
                        :trigger-change="true"></j-upload>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="8">
            <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['storeId', validatorRules.storeId]" :trigger-change="true"
                                 dictCode="sales_physical_store,phystore_name,id" placeholder="请选择所属门店"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>

<!--          <a-col :span="8">-->
<!--            <a-form-item label="制单人" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">-->
<!--              <j-dict-select-tag disabled type="list" v-decorator="['createBy', validatorRules.createBy]"-->
<!--                                 :trigger-change="true" dictCode="sys_user,realname,username"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :span="8">-->
<!--            <a-form-item label="源单类型" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">-->
<!--              <j-dict-select-tag :disabled="readOnly" type="list"-->
<!--                                 v-decorator="['sourceType', validatorRules.sourceType]" :trigger-change="true"-->
<!--                                 dictCode="x_bill_type" placeholder="请选择源单类型"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :span="8">-->
<!--            <a-form-item label="调拨经办" :labelCol="spans.labelCol3" :wrapperCol="spans.wrapperCol3">-->
<!--              <j-select-user-by-dep :disabled="readOnly" v-decorator="['handlerId', validatorRules.handlerId]"-->
<!--                                    :trigger-change="true"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label="备注" :labelCol="spans.labelCol1" :wrapperCol="spans.wrapperCol1">
              <a-textarea :readOnly="readOnly" v-decorator="[ 'remark', validatorRules.remark]" rows="1"
                          autoSize></a-textarea>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="说明" :labelCol="spans.labelCol1" :wrapperCol="spans.wrapperCol1">
              <span>输入物料名称或者料码后，回车进行查询。</span>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a @click="()=> this.moreStatus = !this.moreStatus" style="float: right; margin-top: 10px">
              {{ moreStatus ? '收起' : '展开' }}
              <a-icon :type="moreStatus ? 'up' : 'down'"/>
            </a>
          </a-col>
        </a-row>
      </a-form>

      <onl-cgreport-select-modal
        ref="selectMartialModal"
        title="选择要货申请"
        reportId="1394885719729659906"
        :width="1100"
        :multiSelectable="false"
        :params="requesReportParam"
        @callback="(selectedRows)=>handleSourceOrderSelectCallback(selectedRows)"/>

      <!-- 子表单区域 -->
      <a-tabs v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="明细" :key="refKeys[0]" :forceRender="true">
          <j-editable-table
            :disabled="readOnly"
            :ref="refKeys[0]"
            :loading="stkIoBillEntryTable.loading"
            :columns="stkIoBillEntryTable.columns"
            :dataSource="stkIoBillEntryTable.dataSource"
            :maxHeight="450"
            :rowNumber="false"
            :rowSelection="true"
            :actionButton="!readOnly"
            @valueChange="onValueChange"
            @added="moveEntryAdded">

            <template v-slot:materialSearch="props">
              <a-select style="width: 190px"
                        show-search
                        :show-arrow="false"
                        :filter-option="false"
                        :not-found-content="null"
                        @change="handleMatrialChangeX(props,$event)"
                        @inputKeydown="handleMatrialSearch(props,$event)"
                        @focus="handleMatrialFocus"
                        :options="materialOptions"
                        :disabled="readOnly"
                        :value="props.value"
              ></a-select>
            </template>
            <template v-slot:batchNoSelectMaterialModal="props" style="padding-left: 0">
              <a-button :disabled="readOnly" @click="handleBatchNoSelectMaterial(props)" icon="">选择物料</a-button>
              <material-select-modal
                ref="batchNoSelectMaterialModal"
                title="选择物料"
                filterCode=""
                :width="1100"
                @callback="(selectedRows)=>handleBatchNoSelectMaterialCallback(props,selectedRows)"/>
            </template>
            <template v-slot:batchNoSelectModal="props1" style="padding-left: 0">
              <a-button @click="handleBatchNoSelect(props1)">选择批次</a-button>
              <onl-cgreport-select-modal
                ref="selectModal"
                title="选择库存批次"
                reportId="49d9b3c81f5647dea5b4d1f431613920"
                :width="1100"
                :params="requesReportParam"
                @callback="(selectedRows)=>handleBatchNoSelectCallback(props1,selectedRows)"/>
            </template>

          </j-editable-table>
        </a-tab-pane>

        <template slot="tabBarExtraContent">
          <editable-table-columns-setter :columns="stkIoBillEntryTable.columns" tableName="stkIoBillEntryTable"/>
        </template>
      </a-tabs>
    </a-spin>
  </j-modal>
</template>

<script>
  import pick from 'lodash.pick'
  import {FormTypes, getRefPromise} from '@/utils/JEditableTableUtil'
  import {JEditableTableMixin} from '@/mixins/JEditableTableMixin'
  import { billMaterialSelectMixin } from '../../mixins/billMaterialSelectMixin'
  import JDate from '@/components/jeecg/JDate'
  import JUpload from '@/components/jeecg/JUpload'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {getAction, putAction,postAction} from '@api/manage'
  import {billModalMixin} from '../../mixins/billModalMixin'
  import OnlCgreportSelectModal from '../../components/OnlCgreportSelectModal'
  import EditableTableColumnsSetter from "../../components/EditableTableColumnsSetter";
  import {getFormatDate} from '../../utils/util'
  import {validateEntryNo} from '../../utils/editableTableValidate'
  import MaterialSelectModal from '../../components/MaterialSelectModal'


  export default {
    name: 'MoveBillModal',
    mixins: [JEditableTableMixin, billModalMixin, billMaterialSelectMixin],
    components: {
      EditableTableColumnsSetter,
      JDate,
      JUpload,
      JSelectUserByDep,
      JDictSelectTag,
      OnlCgreportSelectModal,
      MaterialSelectModal
    },
    data() {
      return {
        module_sign:"stk_allo",
        width: '1200px',
        moreStatus: false,
        requesReportParam: {},
        storeWareHouseId: '',
        rootWareHouseId: '40288183712beaa901712c1935d10006',
        // 新增时子表默认添加几行空数据
        tempProps: {},
        addDefaultRowNum: 1,
        validatorRules: {
          stockIoType: {
            rules: []
          },
          billNo: {
            rules: [
              {required: true, message: '请输入单据编号!'},
            ]
          },
          billDate: {
            rules: [
              {required: true, message: '请输入单据日期!'},
            ]
          },
          pushWarehouse: {
            rules: [
              {required: true, message: '请输入调入仓库!'},
            ]
          },
          pullWarehouse: {
            rules: [
              {required: true, message: '请输入调出仓库!'},
            ]
          },
          sourceType: {
            rules: []
          },
          sourceId: {
            rules: []
          },
          sourceNo: {
            rules: []
          },
          clerkId: {
            rules: []
          },
          handlerId: {
            rules: []
          },
          hasRp: {
            rules: []
          },
          isRubric: {
            rules: []
          },
          isSameSettle: {
            rules: []
          },
          supplierId: {
            rules: []
          },
          customerId: {
            rules: []
          },
          attachment: {
            rules: []
          },
          remark: {
            rules: []
          },
          billProcStatus: {
            rules: []
          },
          approverId: {
            rules: []
          },
          flowId: {
            rules: []
          },
          isApproved: {
            rules: []
          },
          effectiveTime: {
            rules: []
          },
          isVoided: {
            rules: []
          },
          isClosed: {
            rules: []
          },
          sysOrgCode: {
            rules: []
          },
          createBy: {
            rules: []
          },
          createTime: {
            rules: []
          },
          updateBy: {
            rules: []
          },
          updateTime: {
            rules: []
          },
        },
        refKeys: ['stkIoBillEntry',],
        tableKeys: ['stkIoBillEntry',],
        activeKey: 'stkIoBillEntry',
        materialOptions: [],
        materialData: [],
        // 明细
        stkIoBillEntryTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '分录号',
              key: 'entryNo',
              type: FormTypes.inputNumber,
              width: "60px",
              validateRules: [
                {required: true, message: '${title}不能为空'},
                {pattern: /^[1-9]\d*$/, message: '请输入正整数'},
                {handler: validateEntryNo}],
            },
            // { //sourceType、sourceEntryId、sourceEntryNo应一起考虑
            //   title: '源单分录号',
            //   key: 'sourceEntryNo',
            //   type: FormTypes.input,
            //   width: "180px",
            //   defaultValue: '',
            //   disabled: true,
            // },
            {
              title: '物料',
              key: 'materialId',
              type: FormTypes.slot,
              width: "200px",
              slotName: 'materialSearch'
            },
            {
              title: '',
              key: 'batchNoSelectMaterialModal',
              type: FormTypes.slot,
              slotName: 'batchNoSelectMaterialModal',
              orgFields: "id,unit_id,code",
              destFields: "materialId,unitId,batchNo",
              width:"100px",
            },
            {
              title: '批次号',
              key: 'batchNo',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{required: true, message: '${title}不能为空'}],
            },
            {
              title: '调出仓库',
              key: 'warehouseId',
              type: FormTypes.hidden,
              dictCode: "bas_warehouse,name,id",
              width: "150px",
              placeholder: '请输入${title}',
              options: [],
              validateRules: [{required: true, message: '${title}不能为空'}],
            },
            {
              title: '',
              key: 'batchNoSelectModal',
              type: FormTypes.slot,
              slotName: 'batchNoSelectModal',
              orgFields: "material_id,warehouse_id,batch_no,unit_id,unit_id,qty,cost,id,supplier_id",
              destFields: "materialId,warehouseId,batchNo,unitId,inventoryUnitId,inventoryQty,inventoryCost,inventoryId,supplierId",
              width: "100px",
            },
            {
              title: '源单位',
              key: 'inventoryUnitId',
              type: FormTypes.select,
              dictCode: "bas_measure_unit,name,id",
              width: "100px",
              disabled: true,
            },
            {
              title: '源库存数量',
              key: 'inventoryQty',
              type: FormTypes.input,
              statistics: "true",
              width: "100px",
              disabled: true,
            },
            {
              title: '调入仓库',
              key: 'inWarehouseId',
              type: FormTypes.hidden,
              dictCode: "bas_warehouse,name,id",
              width: "150px",
              placeholder: '请输入${title}',
              defaultValue: '',
              options: [],
              validateRules: [{required: true, message: '${title}不能为空'}],
            },
            {
              title: '调拨单位',
              key: 'unitId',
              type: FormTypes.select,
              dictCode: "bas_measure_unit,name,id",
              width: "100px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [{required: true, message: '${title}不能为空'}],
              options: [],
            },
            {
              title: '要货数量',
              key: 'qty',
              type: FormTypes.inputNumber,
              statistics: "true",
              width: "100px",
              placeholder: '请输入${title}',
              defaultValue: '',
              validateRules: [
                {required: true, message: '${title}不能为空'},
                // {handler: this.validateQty}
              ]
            },
            {
              title: '调拨实收数量',
              key: 'realQty',
              disabled: true,
              type: FormTypes.inputNumber,
              statistics: "true",
              width: "100px",
            },
            // {
            //   title: '调拨成本',
            //   key: 'cost',
            //   type: FormTypes.inputNumber,
            //   statistics: "true",
            //   width: "100px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '',
            //   disabled: true,
            // },
            {
              title: '源库存批次id',
              key: 'inventoryId',
              type: FormTypes.hidden,
              width: "10px",
              disabled: true,
            },
            // {
            //   title: '源库存成本',
            //   key: 'inventoryCost',
            //   type: FormTypes.input,
            //   statistics: "true",
            //   width: "100px",
            //   disabled: true,
            // },
            {
              title: '备注',
              key: 'remark',
              type: FormTypes.input,
              width: "200px",
              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '源库存供应商',
              key: 'supplierId',
              type: FormTypes.hidden,
              width: "150px",
            },
            // {
            //   title: '备注2',
            //   key: 'remark2',
            //   type: FormTypes.input,
            //   width: "200px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '',
            // },
            // {
            //   title: '备注3',
            //   key: 'remark3',
            //   type: FormTypes.input,
            //   width: "200px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '',
            // },
          ],
        },
        isAprrove: true,
        url: {
          add: "/stock/stkIoBill/add",
          edit: "/stock/stkIoBill/edit",
          approve: "/stock/stkIoBill/approve",
          stkIoBillEntry: {
            list: '/stock/stkIoBill/queryEntryByMainId',
            editingList: '/stock/stkIoBill/queryEditingEntryByMainId'
          },
          getUnitMapper:"/bas/basMaterial/getMapperUnitIdBySign",
          getWareHouseId: "/bas/basWarehouse/queryWarehouseIdByUserCode",
          queryMaterialByCodeOrName: "/bas/basMaterial/queryByCodeOrName",
          batchGetMapperUnitIdBySign: "/bas/basMaterial/batchGetMapperUnitIdBySign",
        }
      }
    },
    created() {
      let that = this
      getAction(this.url.getWareHouseId, {}).then(res => {
        if (res.success) {
          that.storeWareHouseId = res.result
        }
      })
    },
    methods: {
      handleBatchNoSelectMaterial(props){
        let queryParams = {};
        let orgStoreId = 'material_store'
        queryParams[orgStoreId] = ''
        let storeId = this.form.getFieldValue('storeId')
        if(storeId){
          queryParams[orgStoreId] = '*'+storeId+'*'
        }
        this.$refs.batchNoSelectMaterialModal.initQueryParams(queryParams);
        this.$refs.batchNoSelectMaterialModal.visible = true;
      },
      handleBatchNoSelectMaterialCallback(props, selectedRows){
        if (selectedRows) {
          let valArr = [];
          for(let i = 0; i < selectedRows.length; i++) {
            let materialId = selectedRows[i].id;
            let unitId = selectedRows[i].unit_id;
            let materialCode = selectedRows[i].code;
            valArr.push({"materialId":materialId,"unitId":unitId,"batchNo":materialCode});
          }
          if (valArr) {
            postAction(this.url.batchGetMapperUnitIdBySign,{data:valArr,moduleSign:this.module_sign}).then((res) => {
              if (res.success) {
                let newData = res.result;
                //将查询的新计量单位插入selectedRows
                for(let z = 0; z < selectedRows.length; z++) {
                  let orgMaterialId = selectedRows[z].id;
                  for (let w = 0; w <newData.length  ; w++) {
                    let targetMaterialId = newData[w].materialId;
                    if (orgMaterialId === targetMaterialId){
                      let newUnitId = newData[w].unitId;
                      selectedRows[z].unit_id = newUnitId;
                      break;
                    }
                  }
                }
                let { rowId, target } = props;
                let orgFields = props.column.orgFields.split(',');
                let destFields = props.column.destFields.split(',');
                for(let i = 0; i < selectedRows.length; i++) {
                  let values = {};
                  for (let j = 0; j < orgFields.length; j++) {
                    values[destFields[j]] = selectedRows[i][orgFields[j]];
                  }

                  if (i === 0) {
                    target.setValues([{rowKey: rowId, values: values}]);
                  } else {
                    target.add();
                    let rowId2 = target.rows[target.rows.length - 1].id;
                    target.setValues([{rowKey: rowId2, values: values}]);
                  }
                }
              }
            })
          }
          this.initMaterialOptions()
        }
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      moveEntryAdded(event){
        this.onEntryAdded(event)
        const {row, target} = event
        target.setValues([{rowKey: row.id, values: {warehouseId: this.form.getFieldValue('pullWarehouse')}}]);
      },
      handleMatrialChangeX(props,event){
        let materialCode = this.findCodeByMaterialId(event)
        props.target.setValues([{
          rowKey: props.rowId,
          values: {materialId:event,batchNo:materialCode},
        }]);
        this.handleBatchNoSelect(props);
      },
      handleMatrialFocus(){
        this.materialOptions = []
      },
      handleMatrialSearch(props,event,value){
        let that = this
        if(event.key=='Enter'){
          getAction(this.url.queryMaterialByCodeOrName,{target:event.target.value}).then(res=>{
            if(res.success){
              that.materialOptions = []
              res.result.forEach((item)=>{
                that.materialOptions.push({value:item.id,label:item.name+'('+item.code+')'})
              })
            }
          })
        }
      },
      addInit() {
        this.model.stockIoType = '301'
        this.model.isRubric = 0
        //是否有往来
        this.model.hasRp = 0
        //结算是否同出库（或取自系统参数）
        this.model.isSameSettle = 0
        //处理状态：编辑中
        this.model.billProcStatus = '12'

        this.stkIoBillEntryTable.dataSource = [];

        this.materialOptions = []

        // 请求后台的填值规则接口地址
        const url = '/sys/fillRule/executeRuleByCode/'
        const ruleCode = 'stock_io_bill_no'
        const that = this
        putAction(url + ruleCode, {}).then(res => {
          // 执行成功，获取返回的值，并赋到页面上
          if (res.success) {
            that.model.billNo = res.result;
            that.$nextTick(() => {
              that.form.setFieldsValue({'billNo': res.result, 'billDate': getFormatDate(), 'pullWarehouse': this.storeWareHouseId})
            })
          }
        })
      },
      initMaterialOptions(){
        const that = this
        getAction(this.url.queryMaterialByCodeOrName,{target:''}).then(res=>{
          if(res.success){
            that.materialOptions = []
            res.result.forEach((item)=>{
              that.materialOptions.push({value:item.id,label:item.name+'('+item.code+')'})
            })
          }
        })
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {

        if (this.action === 'add') {
          this.addInit()
        }else{
          if(this.readOnly){
            this.initMaterialOptions()
          }
        }
        let fieldval = pick(this.model, 'billNo', 'billDate', 'sourceType', 'sourceId', 'sourceNo', 'handlerId', 'isRubric', 'attachment', 'remark', 'billProcStatus', 'approverId', 'flowId', 'isApproved', 'effectiveTime', 'isVoided', 'isClosed', 'sysOrgCode', 'createBy', 'createTime', 'updateBy', 'updateTime', 'storeId','pushWarehouse','pullWarehouse')
        this.$nextTick(() => this.form.setFieldsValue(fieldval));
        // 加载子表数据
        if (this.model.id) {
          let params = {id: this.model.id}
          let url = this.readOnly ? this.url.stkIoBillEntry.list : this.url.stkIoBillEntry.editingList;
          this.requestSubTableData(url, params, this.stkIoBillEntryTable);
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)

        return {
          ...main, // 展开
          stkIoBillEntryList: allValues.tablesValue[0].values,
        }
      },
      validateError(msg) {
        this.$message.error(msg)
      },
      popupCallback(row) {
        this.form.setFieldsValue(pick(row, 'billNo', 'billDate', 'sourceType', 'sourceId', 'sourceNo', 'handlerId', 'isRubric', 'attachment', 'remark', 'billProcStatus', 'approverId', 'flowId', 'isApproved', 'effectiveTime', 'isVoided', 'isClosed', 'sysOrgCode', 'createBy', 'createTime', 'updateBy', 'updateTime','pushWarehouse','pullWarehouse'))
      },

      //单元值改变一个字符就触发一次
      onValueChange(event) {
        const {type, row, column, value, target} = event
        //触发：物料ID、仓库id、批次号、出库数量触发，前三者引起库存数量、库存成本等变化，
        //      这都需要重新计算，所以：简化为每次change都计算。
        //联动：出库成本
        let qty = Number(value),
          inventoryQty = Number(row.inventoryQty),
          inventoryConst = Number(row.inventoryCost);
        if (!isNaN(qty) && !isNaN(inventoryQty) && !isNaN(inventoryConst) && inventoryQty > 0 &&
          row.unitId && row.unitId !== "" && row.inventoryUnitId && row.inventoryUnitId !== "") {
          const key = row.unitId + "/" + row.inventoryUnitId;
          let rate = row.unitId === row.inventoryUnitId ? 1 : Vue.ls.get(key);
          if (rate == null) {
            const url = '/bas/basMeasureUnit/getRate';
            const params = {materialId:row.materialId,toId: row.unitId, fromId: row.inventoryUnitId};
            getAction(url, params).then(res => {
              if (res.success) {
                rate = res.result;
                Vue.ls.set(key, rate, 7 * 24 * 60 * 60 * 1000)
                let cost = inventoryConst * qty / (inventoryQty * rate);
                cost = cost.toFixed(2)
                target.setValues([{rowKey: row.id, values: {cost: cost}}]);
              }
            });
          } else {
            let cost = inventoryConst * qty / (inventoryQty * rate);
            cost = cost.toFixed(2);
            target.setValues([{rowKey: row.id, values: {cost: cost}}]);
          }
        }
        this.handlePushWarehouseChange(this.form.getFieldValue('pushWarehouse'))
        this.handlePullWarehouseChange(this.form.getFieldValue('pullWarehouse'))

      },

      handleBatchNoSelect(props) {
        let row = props.getValue();
        let orgFields = props.column.orgFields.split(',');
        let destFields = props.column.destFields.split(',');
        let queryParams = {};
        for(let i = 0; i < orgFields.length; i++) {
          if(orgFields[i]!='batch_no'){
            queryParams[orgFields[i]] = row[destFields[i]];
          }
        }
        let warehouseId = 'warehouse_id'
        if(this.storeWareHouseId=='' && row[warehouseId]==''){
          queryParams[warehouseId] = this.rootWareHouseId;
        }else{
          queryParams[warehouseId] = this.storeWareHouseId;
        }
        this.$refs.selectModal.initQueryParams(queryParams);
        this.$refs.selectModal.visible = true;
        this.tempProps = props;
      },

      handleBatchNoSelectCallback(props, selectedRows) {
        if(selectedRows){
          let materiId = selectedRows[0].material_id;
          let newVenUnitId = "";
          postAction(this.url.getUnitMapper, {materialId:materiId,moduleSign:this.module_sign}).then((res) => {
            if (res.success) {
              newVenUnitId = res.result;
            }
            let {rowId, target} = this.tempProps;
            let orgFields = props.column.orgFields.split(',');
            let destFields = props.column.destFields.split(',');
            for (let i = 0; i < selectedRows.length; i++) {
              let values = {};
              for (let j = 0; j < orgFields.length; j++) {
                values[destFields[j]] = selectedRows[i][orgFields[j]];
              }
              if (newVenUnitId){
                values.unitId = newVenUnitId;
              }
              if (i === 0) {
                target.setValues([{rowKey: rowId, values: values}]);
              } else {
                target.add();
                let rowId2 = target.rows[target.rows.length - 1].id;
                target.setValues([{rowKey: rowId2, values: values}]);
              }
            }
          })
        }
        this.handlePushWarehouseChange(this.form.getFieldValue('pushWarehouse'))
        this.handlePullWarehouseChange(this.form.getFieldValue('pullWarehouse'))
      },
      handlePushWarehouseChange(event){
        let { error, values } = this.$refs.stkIoBillEntry.getValuesSync({ validate: false})
        for (let v of values) {
          this.$refs.stkIoBillEntry.setValues([{rowKey: v.id, values: {inWarehouseId: event}}]);
        }
      },
      handlePullWarehouseChange(event){
        let { error, values } = this.$refs.stkIoBillEntry.getValuesSync({ validate: false})
        for (let v of values) {
          this.$refs.stkIoBillEntry.setValues([{rowKey: v.id, values: {warehouseId: event}}]);
        }
      },
      handleSourceOrderSelect(props) {
        let queryParams = {};
        queryParams['bill_no'] = ''
        this.$refs.selectMartialModal.initQueryParams(queryParams);
        this.$refs.selectMartialModal.visible = true;
      },
      handleSourceOrderSelectCallback(selectedRows) {
        this.initMaterialOptions()
        let target = this.$refs.stkIoBillEntry;
        target.rows.forEach(idobject => {
          target.removeRows(idobject.id);
        });
        target.removeRows(target.rows);
        let orgMaterialId = 'material_id';
        let orgOrderNo = '单号';
        let orgInWarehouseId = 'in_warehouse_id';
        let destMaterialId = 'materialId';
        let destUnitId = 'unitId';
        let destQty = 'qty';
        let destInWarehouseId = 'inWarehouseId'
        let material_array = selectedRows[0][orgMaterialId].split(',');
        let inWarehouseId = selectedRows[0][orgInWarehouseId];
        this.form.setFieldsValue({'pushWarehouse': inWarehouseId})
        for (let i = 0; i < material_array.length; i++) {
          let values = {};
          let material_value_array = material_array[i].split('|');
          values[destMaterialId] = material_value_array[0];
          values[destUnitId] = material_value_array[1];
          values[destQty] = material_value_array[2];
          values[destInWarehouseId] = inWarehouseId;
          // if (i === 0) {
          //   let rowId = target.getCleanId(target.rows[i].id);
          //   target.setValues([{rowKey: rowId, values: values}]);
          // } else {
          target.add();
          let rowId2 = target.getCleanId(target.rows[target.rows.length - 1].id);
          target.setValues([{rowKey: rowId2, values: values}]);
          // }
        }
        this.form.setFieldsValue({'sourceNo': selectedRows[0][orgOrderNo]});
      },

      validateQty(type, value, row, column, callback, target) {
        if (type !== 'blur') {
          callback();
          return;
        }

        let {values} = target.getValuesSync({validate: false, rowIds: [row.id]});
        let inventoryQty = Number(values[0].inventoryQty);
        let qty = Number(value);
        if (isNaN(qty) || isNaN(inventoryQty)) {
          callback();
          return;
        }
        if (qty > inventoryQty) {
          callback(false, '不能大于源库存数量！');
          return;
        }

        let inventoryId = values[0].inventoryId;
        if (!inventoryId) {
          callback();
          return;
        }
        let totalQty = 0;
        let obj = target.getValuesSync({validate: false});
        values = obj.values;
        for (let v of values) {
          qty = Number(v.qty);
          if (!isNaN(qty)) totalQty += qty;
        }
        if (totalQty > inventoryQty) {
          callback(false, '该库存批次的出库数量合计不能大于源库存数量！');
        } else {
          callback(true);
        }
      },
    },

  }
</script>

<style lang="less" scoped>
  .ant-row.ant-form-item {
    margin-bottom: 12px;
  }
</style>
